/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useToken from 'hooks/useToken';


import { useToast } from 'context/providers/ToastProvider';
import { Col, Row } from 'react-bootstrap';

import Greetings from './greeting/Greetings';
import ListaPagos from './ListaPagos';

const PagosEmitidos = () => {

    const navigate = useNavigate();
    const { token, idCatTipoUsuario } = useToken();
    const { showErrorToast } = useToast();


    /**
  * Verifica los permisos
  */
    const checkPermisos = async () => {

        const response = await fetch("/api/Administradores/checkPermisos",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const responseType = await response.json();
            console.log(responseType);

            if (responseType.iResponseType == 1) {
                //
            } else {
                navigate("/");
            }

        }
        else {
            navigate("/");
        }
    }

    useEffect(() => {
        if (idCatTipoUsuario != 1) {
            navigate("/");
        }

        checkPermisos();
    }, []);

    //carga los componentes con modularizacion
    return (
        <>
            <Row>
                <Col className="col-12">
                    <Greetings />
                </Col>
                <Col className="col-12">
                    <ListaPagos />
                </Col>
            </Row>

            
        </>
    );
};

export default PagosEmitidos;
